module.exports = __webpack_public_path__ + "img/notice-new.ba8725bc.svg";